// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__gexTZ","text":"Footer_text__8NC56","mores":"Footer_mores__udq23","projectCard":"Footer_projectCard__5slMX"};